import React from 'react'
import "../Product/Intro.css";  
import { useLanguage } from "../LanguageContext";

const AboutUsVision = () => {
    const { language } = useLanguage();
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">VISION AND MISSION</h2>
        <p className="description">
          {language === "en" ? (
            <>
              <strong>Motto</strong>
              <br />
              Together, We Always Grow Smarter.
              <br />
              <br />
            </>
          ) : (
            <>
              <strong>Motto</strong>
              <br />
              Together, We Always Grow Smarter.
              <br />
              <br />
            </>
          )}
        </p>
        <p className="description">
          {language === "en" ? (
            <>
              <strong>Vision</strong>
              <br />
              To be a self-sustaining company that exists to serve others with
              purpose and integrity — trusted by customers, admired by people,
              and chosen for lasting impact.
            </>
          ) : (
            <>
              <strong>Vision</strong>
              <br />
              เรามุ่งเป็นองค์กรที่ยืนหยัดได้ด้วยตนเอง
              เพื่อมีพลังในการส่งต่อคุณค่าแก่ผู้อื่น
              ด้วยจุดยืนที่เปี่ยมด้วยจริยธรรมและความตั้งใจ —
              เป็นองค์กรที่ลูกค้าไว้วางใจ บุคคลทั่วไปชื่นชม
              และเป็นตัวเลือกอันดับต้น ๆ สำหรับความสำเร็จอย่างยั่งยืน
            </>
          )}
        </p>

        <div className="horizontal-text-container">
          <p>About Us</p>
          <p>/</p>
          <p>Vision and Mission</p>
        </div>
      </div>
    </div>
  );
}

export default AboutUsVision